export const MEASUREMENT_AA_QUERY = Object.freeze({
  from: "2026-11-03T00:00:00.000Z",
  to: "2026-11-17T00:00:00.000Z",
  mode: "experiment",
  experiment_id: "measurement_aa_v1",
  experiment_revision: "measurement_schema_v1",
  traffic: "eligible",
});

const READINESS_LABELS = {
  horizon_not_finished: "The registered experiment window has not finished",
  query_window_does_not_match_registered_horizon:
    "The report window does not match the registered horizon",
  ingestion_lag_not_finished: "The 24-hour ingestion lag has not finished",
  insufficient_effective_song_clusters_per_arm:
    "Fewer than 100 effective song clusters in at least one arm",
  insufficient_song_clusters_per_arm:
    "Too few unique song clusters in at least one arm",
  insufficient_primary_observations_per_arm:
    "Too few primary-metric observations in at least one arm",
  insufficient_primary_measurement_coverage:
    "Primary-metric measurement coverage is below the registered threshold",
  primary_measurement_coverage_imbalance:
    "Measurement coverage differs too much between arms",
  sample_ratio_mismatch_not_cleared:
    "The control/treatment split failed the registered SRM check",
  minimum_seven_day_window_not_reached:
    "The minimum seven-day exposure window has not been reached",
  primary_inference_unavailable: "Primary statistical inference is unavailable",
  primary_sensitivity_inference_unavailable:
    "Equal-song-weight sensitivity analysis is unavailable",
  invalid_experiment_assignment_metadata:
    "Experiment assignment metadata is incomplete or inconsistent",
  inconsistent_or_missing_rollout_percent:
    "Rollout percentage is missing or inconsistent",
  rollout_percent_does_not_match_registered_plan:
    "Observed rollout does not match the registered plan",
  assignment_unit_not_uniform_song: "Assignment unit is not uniformly song-level",
  cluster_id_song_id_mismatch: "A cluster ID does not match its song identity",
  experiment_plan_not_registered: "No registered analysis plan was found",
  decision_method_not_implemented: "The registered decision method is not implemented",
};

const numberFormatter = new Intl.NumberFormat("en-US");

export function formatNumber(value, fallback = "—") {
  return typeof value === "number" && Number.isFinite(value)
    ? numberFormatter.format(value)
    : fallback;
}

export function formatPercent(value, digits = 1) {
  return typeof value === "number" && Number.isFinite(value)
    ? `${(value * 100).toFixed(digits)}%`
    : "—";
}

export function formatSeconds(value) {
  return typeof value === "number" && Number.isFinite(value)
    ? `${value.toFixed(1)}s`
    : "—";
}

export function readinessLabel(reason) {
  if (READINESS_LABELS[reason]) return READINESS_LABELS[reason];
  if (reason?.startsWith("session_outcomes_")) {
    return `Session outcomes are not ready (${reason.replace("session_outcomes_", "")})`;
  }
  return String(reason || "Unknown readiness condition")
    .replaceAll("_", " ")
    .replace(/^./, (character) => character.toUpperCase());
}

export function selectPrimaryMetric(report) {
  const analysis = report?.experiment_analysis;
  const metricName = analysis?.analysis_plan?.primary_metric;
  if (!metricName) return { metricName: null, metric: null };
  return {
    metricName,
    metric:
      analysis?.metrics?.[metricName] ||
      analysis?.session_outcomes?.[metricName] ||
      null,
  };
}
